import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CarsCustomerService } from '@customers/services/cars.customer.service';
import { ContentService } from '@reusable/services/common/content.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-my-cars',
  standalone: false,
  templateUrl: './my-cars.component.html',
  styleUrls: ['./my-cars.component.scss']

})
export class MyCarsComponent implements OnInit {
  carsList: any = [];
  deleting: boolean;

  constructor(public cs: ContentService, private carcs: CarsCustomerService, private toastr: ToastrService, private title: Title) {
    title.setTitle('سبيرو - سياراتي');
  }

  ngOnInit() {
    this.getMyCarsList();
  }

  getMyCarsList() {
    this.carcs.listCars('-createdAt', 30, 1).subscribe((data: any) => {
      this.deleting = false;
      this.carsList = data.cars;
    });
  }

  deleteCar(id) {
    this.deleting = true;
    this.carcs.removeCar(id).subscribe(
      (data:any) => {
        if (data.case === 1) {
          // we will not toggle the deleting boolen and will let getMyCarsList do the trick
          this.getMyCarsList();
          // this.toastr.success('تم حذف السيارة بنجاح');
        } else {
          this.deleting = false;
        }
      },
      err => {
        // this.toastr.error(err);
        this.deleting = false;
      }
    );
  }
}